import { useEffect } from 'react';

import { initSnowplow } from '../snowplow';
import { useAppSelector } from '../../redux/app/hooks';
import { RootState } from '../../redux/app/store';

/**
 * Initializes Snowplow when the EnableSnowplow feature flag is true.
 * - Development (yarn start): collector → snowplow-test.visma.com.
 * - Production (yarn build): collector → snowplow.visma.com.
 * No .env change needed; NODE_ENV is set by the build (development vs production).
 */
export function useSnowplowInit(): void {
    const enableSnowplow = useAppSelector((state: RootState) => state.app.serviceInfo.featureFlags.EnableSnowplow);
    const shouldInit = enableSnowplow;

    useEffect(() => {
        if (shouldInit) {
            initSnowplow(true);
        }
    }, [shouldInit]);
}
